import React from 'react';
import BookIcon from '../../../../assets/img/icons/book.svg';
import ClockIcon from '../../../../assets/img/icons/clock-o.svg';
import ForkIcon from '../../../../assets/img/icons/code-fork.svg';
import GavelIcon from '../../../../assets/img/icons/gavel.svg';
import UserIcon from '../../../../assets/img/icons/user.svg';
import type {VersionObject} from '../../../../types.d';
import CheckUrl from './CheckUrl';

export interface MetadataProps {
	metadata: {
		software: {
			documentationUrl?: string
			newestVersion?: VersionObject & { versionDatePrettified: string }
			licenseType: {
				name: string
				url?: string
			}
			sourceCodeLink?: string
			tutorialUrl?: string
		}
		vendor?: {
			name: string
			url: string
		}
	}
}

export default function Metadata({metadata}: MetadataProps) {
	return (
		<div className="software-show__metadata-bar">
			<div className="software-show__metadata-list-container">
				<ul className="software-show__metadata-list">

					{metadata.software.licenseType && metadata.software.licenseType.name && (
						<li className="software-show__metadata-item software-show__metadata-item--license">
							<div className="software-show__metadata-icon"><GavelIcon viewBox="0 0 1792 1792"/></div>
							<span className="software-show__metadata-label">License: </span>
							<CheckUrl
								url={metadata.software.licenseType.url}
								normalText={metadata.software.licenseType.name}
								shortText={metadata.software.licenseType.name}
							/>
						</li>
					)}

					{metadata.software.documentationUrl && (
						<li className="software-show__metadata-item software-show__metadata-item--doc-link">
							<div className="software-show__metadata-icon"><BookIcon viewBox="0 0 1792 1792"/></div>
							<CheckUrl
								url={metadata.software.documentationUrl}
								normalText="Documentation"
								shortText="Docs"
							/>
						</li>
					)}

					{metadata.software.tutorialUrl && (
						<li className="software-show__metadata-item software-show__metadata-item--tutorial-link">
							<div className="software-show__metadata-icon"><BookIcon viewBox="0 0 1792 1792"/></div>
							<CheckUrl
								url={metadata.software.tutorialUrl}
								normalText="Tutorial"
								shortText="Tutorial"
							/>
						</li>
					)}

					{metadata.software.newestVersion && (
						<li className="software-show__metadata-item software-show__metadata-item--version">
							<div className="software-show__metadata-icon"><ForkIcon viewBox="0 0 1792 1792"/></div>
							<span className="software-show__metadata-label">Version: </span>
							<CheckUrl
								url={metadata.software.sourceCodeLink}
								normalText={metadata.software.newestVersion.versionNumber}
								shortText={metadata.software.newestVersion.versionNumber}
							/>


						</li>
					)}

					{!metadata.software.newestVersion && metadata.software.sourceCodeLink && (
						<li className="software-show__metadata-item software-show__metadata-item--source">
							<div className="software-show__metadata-icon"><ForkIcon viewBox="0 0 1792 1792"/></div>
							<CheckUrl
								url={metadata.software.sourceCodeLink}
								normalText="Source"
								shortText="Source"
							/>
						</li>
					)}

					{metadata.software.newestVersion && (
						<li className="software-show__metadata-item software-show__metadata-item--date">
							<div className="software-show__metadata-icon"><ClockIcon viewBox="0 0 1792 1792"/></div>
							<span className="software-show__metadata-label">Date: </span>
							<span className="software-show__metadata-text">
								<span className="software-show__metadata-text--normal">{metadata.software.newestVersion.versionDatePrettified}</span>
								<span className="software-show__metadata-text--short">{metadata.software.newestVersion.versionDatePrettified}</span>
							</span>
						</li>
					)}

					{metadata.vendor && (
						<li className="software-show__metadata-item software-show__metadata-item--vendor">
							<div className="software-show__metadata-icon"><UserIcon viewBox="0 0 1792 1792"/></div>
							<span className="software-show__metadata-label">By: </span>
							<CheckUrl
								url={metadata.vendor.url}
								normalText={metadata.vendor.name}
								shortText={metadata.vendor.name}
							/>
						</li>
					)}

				</ul>
			</div>
		</div>
	);
}
